export interface PromptOptions {
    title: string;
    message?: string;
    inputLabel: string;
    value?: string;
    placeholder?: string;
    inputType?: 'text' | 'url';
    tone?: 'primary' | 'info' | 'warning' | 'danger';
    confirmLabel?: string;
    cancelLabel?: string;
    icon?: string;
}

export interface AlertOptions {
    title: string;
    message: string;
    tone?: 'primary' | 'info' | 'warning' | 'danger';
    label?: string;
    icon?: string;
}

declare global {
    interface Window {
        SpPrompt?: (options: PromptOptions) => Promise<string | null>;
        SpAlert?: (options: AlertOptions | string) => Promise<void>;
        SpToast?: {
            success: (title: string, message?: string) => void;
            error: (title: string, message?: string) => void;
            info: (title: string, message?: string) => void;
            warning: (title: string, message?: string) => void;
        };
    }
}

export async function promptText(options: PromptOptions): Promise<string | null> {
    if (typeof window.SpPrompt === 'function') {
        return window.SpPrompt(options);
    }
    console.warn('[platform-interactions] SpPrompt is unavailable; input cancelled.');
    return null;
}

export async function showAlert(options: AlertOptions): Promise<void> {
    if (typeof window.SpAlert === 'function') {
        await window.SpAlert(options);
        return;
    }
    console.warn(`[platform-interactions] ${options.title}: ${options.message}`);
}

export interface ConfirmOptions {
    title: string;
    message: string;
    tone?: 'primary' | 'info' | 'warning' | 'danger';
    confirmLabel?: string;
    cancelLabel?: string;
    icon?: string;
}

export async function confirmAction(options: ConfirmOptions): Promise<boolean> {
    const spConfirm = (window as unknown as { SpConfirm?: (opts: ConfirmOptions) => Promise<boolean> }).SpConfirm;
    if (typeof spConfirm === 'function') return spConfirm(options);
    console.warn(`[platform-interactions] SpConfirm is unavailable; "${options.title}" cancelled.`);
    return false;
}

export function showToast(kind: 'info' | 'warning' | 'error', title: string, message?: string): void {
    if (window.SpToast) {
        window.SpToast[kind](title, message);
        return;
    }
    console.info(`[platform-interactions] ${title}${message ? `: ${message}` : ''}`);
}

export function showSuccess(title: string, message?: string): void {
    if (window.SpToast) {
        window.SpToast.success(title, message);
        return;
    }
    console.info(`[platform-interactions] ${title}${message ? `: ${message}` : ''}`);
}

